angular.module('logbook', [
    'ngRoute',
    'ui.bootstrap',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.cellNav',
    'ui.grid.draggable-rows',
    'ngSanitize',
    'ngCookies',
    'xeditable',
    'smart-table',
    'ngResource',
	'angularFileUpload',
    'formly',
    'formlyBootstrap',
    'nvd3',
    'angularAwesomeSlider',
    'mwl.confirm',
    'infinite-scroll',
    'ae-datetimepicker',
    'angulartics',
    'angulartics.google.analytics',
    'onsite',
    'sentinel'
]);

export { };